import { Controller } from "@hotwired/stimulus"

// Focuses a field when its Bootstrap modal opens. Bootstrap moves focus onto the modal itself, so the
// HTML autofocus attribute has no effect inside one.
//
// Attach to the .modal element and mark the field with data-modal-autofocus-target="field".
export default class extends Controller {
  static targets = ["field"]

  connect() {
    this.focusField = this.focusField.bind(this)
    this.element.addEventListener("shown.bs.modal", this.focusField)
  }

  disconnect() {
    this.element.removeEventListener("shown.bs.modal", this.focusField)
  }

  focusField() {
    if (this.hasFieldTarget) this.fieldTarget.focus()
  }
}
